import request from '../../utils/request'

const preFix = '/goods';

export const reqListGoods = (data) => {
    return request({
        url: preFix + '/page',
        method: 'POST',
        data: data
    })
}
export const reqInsertGoods = (data) => {
    return request({
        url: preFix + '/insert',
        method: 'POST',
        data: data
    })
}
export const reqUpdateGoods = (data) => {
    return request({
        url: preFix + '/update',
        method: 'POST',
        data: data
    })
}
export const reqDeleteGoodsById = (data) => {
    return request({
        url: preFix + '/delete',
        method: 'get',
        params: data
    })
}
export const reqChangeGoodsStatus = (data) => {
    return request({
        url: preFix + '/changeStatus',
        method: 'get',
        params: data
    })
}
export const reqGetGoodsById = (data) => {
    return request({
        url: preFix + '/detail',
        method: 'get',
        params: data
    })
}
export const reqCheckCustomizeGoods = (data) => {
    return request({
        url: preFix + '/checkCustomizeGoods',
        method: 'POST',
        data: data
    })
}
